import { createBrowserHistory } from 'history';

const getBasename = () => {

    const pathname = window.location.pathname;
    const pathPieces = pathname.split("/");
    let tmpBasename = "nederpoort";
    if (pathPieces.length > 1) {
        tmpBasename = pathPieces[1];
    }

    return tmpBasename;
}

export const basename = getBasename();

export const createCustomTimeout = (ms) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
}

export function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const promise = new Promise((resolve, reject) => {
    setTimeout(() => resolve("ready"), 1000)
});

export const history = createBrowserHistory({
    basename: `/${basename}/`
});
